import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingObjectivesComponentData extends ConvertedComponentData {
  trainingId?: string;
}

export const TRAINING_OBJECTIVES_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingObjectivesComponentData>[]>('TrainingObjectivesConverter')
